module.exports = require("core-js/library/fn/weak-map");


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/core-js/weak-map.js
 ** module id = 222
 ** module chunks = 0
 **/